import React from "react";
import { useSelector } from "react-redux";
import { Typeform } from "@minerva-analytics/pantheon";
import { JUMP_TEXT_PRIMARY, JUMP_TEXT_SECONDARY, JUMP_TITLE } from "../../text";
import {
  HomeTitle,
  TypeformContainer,
  SubscribeBodyText,
} from "./SubscribeJump.styles";

const SubscribeJump = () => {
  const email = useSelector((state) => state.subscription.email);

  return (
    <>
      <HomeTitle>{JUMP_TITLE}</HomeTitle>
      <SubscribeBodyText>
        {JUMP_TEXT_PRIMARY.replace("{EMAIL}", email)}
      </SubscribeBodyText>
      <SubscribeBodyText>{JUMP_TEXT_SECONDARY}</SubscribeBodyText>
      <TypeformContainer>
        <Typeform formID="uQFjqpMK" parameters={{ email }} />
      </TypeformContainer>
    </>
  );
};

export default SubscribeJump;
